(function () {
    'use strict';

    angular
        .module('app')
        .controller('contectModalController', contectModalController);

    function contectModalController($uibModalInstance, modalService, e2eService, headerService,
        $rootScope, loginService, iAmNotRobot, userData, $http, apiUrl) {
        var vm = this;
        vm.cancel = cancel;
        vm.autoFill = autoFill;
        vm.submit = submit;
        vm.iAmNotRobot = iAmNotRobot;

        init();

        function init() {
            vm.view={
                show: false
            }
            vm.data = {};
            vm.isLogin = userData.isLogin;
            vm.data.name = userData.cName;
            vm.data.email = userData.email;
            
            if (!sessionStorage.getItem('token')) {
            //     loginService.getSsoInfo().then(function(data) {
            //         vm.data.name = sessionStorage.getItem('cName');
            //         vm.data.email = data.data.email;
            //         vm.isLogin = true;
            //     });
                vm.view.show = true;
            }

        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function autoFill() {
            e2eService.contactMe(vm.data);
        }

        function specialKeywordVerification(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function submit() {
            if(specialKeywordVerification(vm.data.name))
            {
                toastr.warning($rootScope.translate.commonName + $rootScope.translate.specialKeywords);
                return false;
            }
            else if(specialKeywordVerification(vm.data.content))
            {
                toastr.warning($rootScope.translate.commonContent + $rootScope.translate.specialKeywords);
                return false;
            }


            if (vm.isLogin) {
                //已登入狀態下，略過圖形驗證
                headerService.contactMe(vm.data).then(function () {
                toastr.success($rootScope.translate.sendMailSuccess);
                $uibModalInstance.dismiss('cancel');
                });
            } else {
                if(specialKeywordVerification(vm.login.inputVerify))
                {
                    toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                    return false;
                }
                
                if($('#inputVerify').val().length == 4){
                    var paramsData = {
                        name: vm.data.name,
                        email: vm.data.email,
                        content: vm.data.content,
                        inputVerify: $('#inputVerify').val().toUpperCase(),
                        isPass: $('#isPass').val(),
                        SecretKey: "1"
                    };
                    
                    headerService.contactMe(paramsData).then(function (data) {
   
                        if (data) {
                            toastr.success($rootScope.translate.sendMailSuccess);
                            $uibModalInstance.dismiss('cancel');
                        }else{
                            toastr.warning($rootScope.translate.commonReCaptchaFail);
                        }
                    });
                }else
                {
                    toastr.warning($rootScope.translate.commonIncorrectFormat);
                }

            }
        }

    }
})();